import React, { Component }from 'react';
import HttpUtil from '../commonjs/httpUtil';
import keyListener from '../commonjs/keyListener';
import SignOut from './signOut';
import $ from 'jquery';
import  '../commonjs/GITV-JD';
import method from '../commonjs/method';
import KeyCode from '../commonjs/keyCodes';
import Method from '../commonjs/comModule';
import FirstScreen from './firstScreen';
import Cascade from './cascade';
import RequestUrl from '../commonjs/urlConfiger';
let root,pageHeight=0;
let partnerCode = "LNYD",popupType="";//是否配置了退出挽留弹窗;
const fontSize = 100;
if(window._APP){
    partnerCode = window._APP.getPartnerCode();
}
export default class HomePage extends Component{
    constructor(props) {
            super(props);
            this.state = {
              pubData:"",//弹窗数据
              render:false,//减少重复刷新
              errorTips:"",//错误提示
              userType:"1",//是否是vip用户
              firstScreen:[],//positionType=1数据
              pbJson:"",//子组件获取PB数据
              pubType:"",//退出挽留
              comBJ:"",//背景图
              onOff:true,//是否选中默认焦点
              prohibit:true,//请求分页时禁止相应遥控的下键
              numStatus:true,//接口状态是否有数据 ture有数据 false没有数据
              pages:"1",//瀑布流页数，默认是请求第一页
              h5PageList:""//positionType=2专题活动页面列表数据
            };
    }
    componentWillMount() { //组件初始化时只调用，以后组件更新不调用，整个生命周期只调用一次，此时可以修改state。

    }
    shouldComponentUpdate (nextProps, nextState) {
        if(nextState.render){
          return true;
        }
        return false;
    }
    componentDidMount() {//组件渲染之后调用，只调用一次。

        keyListener.set(this.handleKeyDownBack);

        this.h5PagePositionList(this.state.pages);
        this.h5PagePopupList(this.state.pages);
        let dom = document.getElementById("main");
         root =  window.FocusEngine.render(dom);
         this.activeFouns(root);
    }
    h5PagePositionList = (pages) =>{//H5专题---活动页面位置列表
      let _this = this;
      HttpUtil.getP(RequestUrl.h5PagePositionList(pages)).then((json) => {
        console.log("listData---"+JSON.stringify(json))
        if(json.code === "A000000" && typeof json ){

          this.setState({comBJ:json.data.list[0].positionBgPic,render:false});
          if(json.data.list[0].posY > pageHeight){
            pageHeight = json.data.list[0].posY;
          }
          for(let i=0;i<json.data.list.length;i++){
            if(json.data.list[i].posY>pageHeight){
                pageHeight = json.data.list[i].posY;
            }


            if(json.data.list[i].isFocus == "1") {
              this.setState({comBJ:json.data.list[i].positionBgPic,render:false});
            }

          }
          RequestUrl.getPBEnter({oid:"00000000",pat:json.data.screeninfo.typeName,pan:json.data.screeninfo.contentText,paid:json.data.screeninfo.contentId},"0");
          this.setState({
            firstScreen:this.state.firstScreen.concat(json.data.list),
            pbJson:json.data,
            prohibit:true,
            render:true,

          });
            this.comReRender();


            let isFocusId = "isFocus_1_0";
            if(window.FocusEngine.getWidgetById('isFocus')){
              isFocusId = "isFocus";
            }else if(window.FocusEngine.getWidgetById('isFocus_0')){
              isFocusId = "isFocus_0";
            }
            console.log(isFocusId)

            if(this.state.onOff && window.FocusEngine.getWidgetById(isFocusId)){
              window.FocusEngine.getWidgetById(isFocusId).focus();
            }
            let cont = $("#"+isFocusId).attr("data-cont");
            let colors = $("#"+isFocusId).attr("data-border");
            let wid = $("#"+isFocusId).attr("data-width");
            let hei = $("#"+isFocusId).attr("data-height");
            let scales =   Method.enlarge(wid,hei);
            let top = $("#"+isFocusId).attr("data-top");
              this.setState({onOff:false});


              if(cont != 0){
                  $("#"+isFocusId).children().addClass("max-scale");
              }
              if(cont == 0){//0：不显示位移图

                  this.transformScale(isFocusId,colors,"","center",scales,hei,top);
              }else if(cont == 1){//1：向左放大

                  this.transformScale(isFocusId,colors,"max-scale","left",scales,hei,top);
              }else if(cont == 2){//2：向上放大

                  this.transformScale("isFocus",colors,"max-scale","bottom",scales,hei,top);
              }else if(cont == 3){//3：向右放大

                  this.transformScale("isFocus",colors,"max-scale","right",scales,hei,top);
              }else if(cont == 4){//4：展示不放大

                  $("#"+isFocusId).css({
                    border:".03rem solid "+colors+""
                  });

              }



        }else if(json.code === "A000004"){

          this.setState({numStatus:false});

        }

      },()=>{
        _this.errorTipsCom("tips","网络链接失败，请稍后再试！");
      });
    }
  h5PagePopupList = (pages) =>{//弹窗接口
    let _this = this;
    HttpUtil.getP(RequestUrl.h5PagePopupList(pages)).then((json) => {
      console.log("popData---"+JSON.stringify(json))
      if(json.code === "A000000" && typeof json){//有退出挽留弹窗

        popupType = "Y";
        this.setState({pubData:json.data.list,render:false});
        if(window._APP) window._APP.setRoot("false");

      }else if(json.code === "A000004"){//没有退出挽留弹窗

        popupType = "";
        if(window._APP) window._APP.setRoot("true");
      }

    },()=>{
      _this.errorTipsCom("tips","网络链接失败，请稍后再试！");
    });
  }

    // 确定键去往Android
    activeFouns = (root,toor) =>{
        let _this = this,off=false;
        root.on("okdown", function(e) {//确定
          if(e.target.con.dataset.info){

              RequestUrl.getPBEnter(
                {
                  oid:e.target.con.dataset.num,
                  on:e.target.con.dataset.positionname,
                  pat:_this.state.pbJson.screeninfo.typeName,
                  pan:_this.state.pbJson.screeninfo.contentText,
                  paid:e.target.con.dataset.contentid,
                  cont:e.target.con.dataset.positionname
                },"0");
                let panPaid = {pan:_this.state.pbJson.screeninfo.contentText,paid:e.target.con.dataset.contentid}

              _this.toAndroid(e.target.con.dataset.info,panPaid);
          }else{
              _this.errorTipsCom("tips","自定义模块跳转数据为空~~");
          }

        });

        root.on("switchend", function(e) {//组件焦点已经处于边缘，继续按方向键时会触发到达边缘的事件。

          if(e.keyCode == KeyCode.down){//到达底部对比是否还是要分页数据如果有就请求分页数据

            let total = _this.state.pbJson.total;//总条数
            let pageSize = _this.state.pbJson.pageSize;//每页的条数
            let pages = Math.ceil(total / pageSize);//计算出的总条数
            let currentPages = parseInt(_this.state.pages);//当前的页数

            if(currentPages < pages && _this.state.prohibit){
              _this.setState({
                pages:currentPages+1,
                prohibit:false
              })
              _this.h5PagePositionList(_this.state.pages);
            }else{
              console.log("禁止了！！！")
            }

          }

        });
          root.on("keydown", function(e) {//还原位置
            if(off){
              let hei = e.target.con.dataset.height;
              let myTop = e.target.con.dataset.top;
              const fontTop = 42;
              const fontHeight = 39;
              if(e.target.con.dataset.cont == 1 || e.target.con.dataset.cont == 2 || e.target.con.dataset.cont == 3){
                setTimeout(()=>{
                  $(".max-scale").css({
                    // top: "-.36rem",
                    // transform: "translate3d(0,0,0)",
                  //  top:(parseFloat(myTop) - parseFloat(fontTop)) / fontSize + "rem",
                    //height:(parseFloat(hei) + parseFloat(fontHeight)) / fontSize + "rem"
                  });
                },10);

              }
              off=false;
            }

          });
        root.on("keyup", function(e) {//首屏切换焦点时切换背景

          off=true;
          if(e.target.con.dataset.go){
              _this.setState({comBJ:e.target.con.dataset.bg});
          }


            $(".topic-firstScreen, .max-scale,.topic-key").css({
              transform: "translate3d(0,0,0)",
              transformOrigin:""
            });
            let tiTop = e.target.con.dataset.top;


            $(".topic-driftPic").removeClass("max-scale");
            $("#"+e.target.id).children().addClass("max-scale");

            $(".topic-firstScreen,.topic-key").css({
               border:".03rem solid transparent"
            });
            $(".topic-driftPic").css({
              top:"-.45rem",
              transform: "translate3d(0,0,0)",
            });
            let scales =   Method.enlarge(e.target.con.dataset.width,e.target.con.dataset.height);




            if(e.target.con.dataset.cont == 0){//0：不显示位移图

                _this.transformScale(e.target.id,e.target.con.dataset.border,"","center",scales,e.target.con.dataset.height,tiTop);
            }else if(e.target.con.dataset.cont == 1){//1：向左放大

                _this.transformScale(e.target.id,e.target.con.dataset.border,"max-scale","right",scales,e.target.con.dataset.height,tiTop);
            }else if(e.target.con.dataset.cont == 2){//2：向上放大


                _this.transformScale(e.target.id,e.target.con.dataset.border,"max-scale","bottom",scales,e.target.con.dataset.height,tiTop);
            }else if(e.target.con.dataset.cont == 3){//3：向右放大

                _this.transformScale(e.target.id,e.target.con.dataset.border,"max-scale","left",scales,e.target.con.dataset.height,tiTop);

            }else if(e.target.con.dataset.cont == 4){//4：展示不放大

              $("#"+e.target.id).css({
                border:".03rem solid "+e.target.con.dataset.border+""
              });

            }

        })
    }

    transformScale = (id,color,maxScale,direction,scales,maxScaleHei,posY) =>{//位移图放大动画 id:背景的id color:背景的选中border颜色 maxScale:位移图的calss direction:位移方向 scales放大倍数,maxScaleHei位移图高度,posY后的top值
      const top = 36;
      const maxTop = 57;
      $("#"+id).css({
        transform: "scale("+scales.backdrop+")",
        transformOrigin:"center",
        border:".03rem solid "+color+"",
        transition:".3s",
      });
      console.log(direction)
      let fx = direction == "bottom" ? "":" bottom";
      maxScale && maxScale ?
      $("."+maxScale).css({
        //top:"-.4rem",
        //top:direction == "bottom"?(parseFloat(posY) - parseFloat(top)) / fontSize + "rem": (parseFloat(posY) - parseFloat(maxTop)) / fontSize+ "rem",//(key.posY - 39) / 100 +"rem",

        transform: "scale("+scales.shifting+")",
        //transformOrigin:direction,
        transformOrigin:direction+fx,
        transition:".3s"
      }) : "";
    }

    //刷新焦点
    comReRender = () =>{

      root.reRender();
    }
    handleKeyDownBack = (keyCode) => {

        if(keyCode == 8 && popupType == "Y"){

            this.setState({pubType:"signOut",render:true});
            root.freeze()
            if(window._APP) window._APP.setRoot("true");
        }

    }

    offPub = (keyCode,val) =>{
      this.setState({
          pubType:"",
          errorTips:"",
      },()=>{
        setTimeout(()=>{
          root.activate();
          keyListener.set(this.handleKeyDownBack);
        },100);
      });

      if(val){

        if(window._APP) window._APP.setRoot("false");
      }
    }

    toAndroid = (data,jsonPb) => {//跳转Android
      console.log("toAndroid----- "+data);

      let json = JSON.parse(data);
      if(!(json.intent)){
        if(!(json.extras)){
          json.extras = {}
        }
        json.extras.pageId = jsonPb.paid;
        json.extras.pageName = jsonPb.pan;
        json.extras.pageProductName = method.getValue("apppag")?method.getValue("apppag"):"_";
        json.extras.pageProductLocation = method.getValue("position")?method.getValue("position"):"_";
      }else{
        if(!(json.intent.extras)){
          json.intent.extras = {}
        }
        json.intent.extras.pageId = jsonPb.paid;
        json.intent.extras.pageName = jsonPb.pan;
        json.intent.extras.pageProductName = method.getValue("apppag")?method.getValue("apppag"):"_";
        json.intent.extras.pageProductLocation = method.getValue("position")?method.getValue("position"):"_";
      }


      console.log("pathJson----- "+JSON.stringify(json));
      window._APP && window._APP.jumpIntent(JSON.stringify(json));
    }
    errorTipsCom = (pubType,errorTips) => {//封装公共接口请求错误提示
      let _this = this;
      _this.setState({
          pubType:pubType,
          errorTips:errorTips,
      },() => {
          setTimeout(()=>{
              _this.setState({
                  pubType:"",
                  errorTips:"",
              });
          },3000);
      });
    }

    render(){
      let { pubType , firstScreen,h5PageList,pubData,pbJson,comBJ} = this.state;
      const onTop = 39;
      // style={{background:"url("+comBJ+") no-repeat",backgroundSize:"100% 100%"}}
        return(
            <div className="main" id="main" data-role="Scroll" data-cfg="disable_cache_pre:yes">
              <img src={comBJ} className="com-bg"/>
              <div className="page-content">
                    <div className="scroll-list roll-s">
                        <div className="first-focus" style={{height:pageHeight+"px"}}>
                            {
                            firstScreen && firstScreen.map((key,i)=>{

                                if(key.positionType==1){
                                  let styles = {
                                      top:key.posY / fontSize +"rem",
                                      left:key.posX / fontSize + "rem",
                                      width:key.positionPicWeight / fontSize + "rem",
                                      height:key.positionPicHeight / fontSize + "rem",
                                      background:"url("+key.positionPic+") no-repeat",
                                      backgroundSize:"100% 100%"
                                  };
                                  let drift = {//位移图样式
                                       top: "-.39rem",
                                      // left:key.posX / fontSize + "rem",
                                      width:key.positionPicWeight / fontSize + "rem",
                                      height:(key.positionPicHeight + onTop) / fontSize + "rem",
                                      background:"url("+key.contDriftPic+") no-repeat",
                                      backgroundSize:"100% 100%"
                                  };

                                  let idIsFocus = key.isFocus == 1 ? "isFocus" : "isFocus_"+i;

                                  return(
                                    <div key={i+"Y"}>
                                        <div key={i} data-width={key.positionPicWeight} data-top={key.posY} data-height={key.positionPicHeight}  data-border={key.borderColor} data-cont={key.isDisplayContDriftPic} data-contid={key.id} data-positionName={key.positionName} data-contentId={pbJson.screeninfo.contentId} data-num={pbJson.screeninfo.contentId+"0100"+key.focusOrder} id={idIsFocus} data-go="Y" data-bg={key.positionBgPic} data-info={JSON.stringify(key.appInfo)} style={styles} className="topic-firstScreen"  data-role="Widget">
                                          {key.isDisplayContDriftPic == 0 ? "" : <div   className="topic-driftPic" style={drift}></div> }
                                        </div>

                                    </div>
                                  )
                              }else {
                                return(
                                  <Cascade transformScale={this.transformScale} pageNum={i+1} pbJson={pbJson} comReRender={root} key={i} errorTipsCom={this.errorTipsCom} msg = {key} />
                                )

                              }
                                  //firstScreen ? <FirstScreen msg = {firstScreen} />:""
                              })

                            }
                        </div>


                    </div>
                </div>
                {
                  pubType == "tips"?<div className="com-tips">{this.state.errorTips}</div>:""
                }
                {
                  pubType == "signOut"?<SignOut transformScale={this.transformScale} pbJson={pbJson} toAndroid={this.toAndroid} pubData={pubData}  offPub={this.offPub} />:""
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/homePage.js